import { getAvailableMonthsForTimesheet } from "@/lib/timesheetRules";

export const getMissionDisplayName = (mission) =>
  mission?.client_name?.trim() || "Intercontrat";

export const filterDeclarableMonths = (months = [], mission, options = {}) => {
  if (!Array.isArray(months)) {
    return [];
  }

  const allowedMonths = new Set(getAvailableMonthsForTimesheet({
    contractStartDate: mission?.start_date,
    year: options?.year,
    now: options?.now,
  }).map((item) => item.key));

  if (allowedMonths.size === 0) {
    return [];
  }

  return months.filter((month) => allowedMonths.has(month?.month));
};
